import { Box, Typography } from '@mui/material'
import { volunteerPhoto, volunteerPhotoMask } from '../../assets/index'
import PrimaryButton from './PrimaryButton'
import { HOME_MOBILE_MQ } from '../home/homeMobileLayout'

export default function VolunteerBanner() {
  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        width: '100%',
        maxWidth: 1520,
        mx: 'auto',
        minHeight: { xs: 446, sm: 320, lg: 294 },
        height: { lg: 294 },
        [HOME_MOBILE_MQ]: { minHeight: 446, borderRadius: '16px' },
        borderRadius: '20px',
        overflow: 'hidden',
        bgcolor: '#e9e9e9',
        boxSizing: 'border-box',
      }}
    >
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          top: '50%',
          left: { xs: '58%', sm: '56%', lg: 'calc(50% + 17px)' },
          transform: 'translate(-50%, -50%)',
          width: { xs: '220%', sm: '190%', lg: 1632 },
          height: { xs: '140%', sm: '130%', lg: 774 },
          pointerEvents: 'none',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            transform: 'scaleY(-1) rotate(180deg)',
          }}
        >
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              height: '100%',
              WebkitMaskImage: `url(${volunteerPhotoMask})`,
              maskImage: `url(${volunteerPhotoMask})`,
              WebkitMaskSize: '100% 100%',
              maskSize: '100% 100%',
              WebkitMaskRepeat: 'no-repeat',
              maskRepeat: 'no-repeat',
              WebkitMaskPosition: 'center',
              maskPosition: 'center',
              overflow: 'hidden',
            }}
          >
            <Box
              component="img"
              src={volunteerPhoto}
              alt=""
              sx={{
                position: 'absolute',
                left: 0,
                top: '-0.05%',
                width: '99.99%',
                height: '100.1%',
                maxWidth: 'none',
                display: 'block',
                objectFit: 'cover',
              }}
            />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: { xs: '14px', lg: '32px' },
          width: '100%',
          maxWidth: { xs: 322, sm: 420, md: 520, lg: 599 },
          p: { xs: '20px', sm: 4, md: 5, lg: '60px' },
          [HOME_MOBILE_MQ]: { maxWidth: 322, p: '20px', gap: '14px' },
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '14px', lg: '14px' } }}>
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: 24, sm: 32, lg: 30 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#111',
              [HOME_MOBILE_MQ]: { fontSize: 24 },
            }}
          >
            Become A Volunteer
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 15, sm: 18, lg: 20 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#111',
              [HOME_MOBILE_MQ]: { fontSize: 15 },
            }}
          >
            Join Disha Foundation to inspire change, empower youth, and create impact through
            leadership and community service.
          </Typography>
        </Box>

        <PrimaryButton
          to="/become-a-change-maker"
          sx={{
            [HOME_MOBILE_MQ]: {
              mt: '19px',
            },
          }}
        >
          Become a change maker
        </PrimaryButton>
      </Box>
    </Box>
  )
}
